import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import classes from './deleteConfirmationModalBpmByNdcAndJobType.module.scss';

interface DeleteConfirmationModalBpmByNdcAndJobTypeProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
  itemName: string;
}

const DeleteConfirmationModalBpmByNdcAndJobType: React.FC<
  DeleteConfirmationModalBpmByNdcAndJobTypeProps
> = ({ visible, onHide, onConfirm, itemName }) => {
  return (
    <Dialog
      header="Delete This Row?"
      visible={visible}
      onHide={onHide}
      className={classes.modal}
      style={{ width: '450px' }}
    >
      <p>Are you sure you want to delete this BPM by NDC and Job Type record?</p>
      {itemName && (
        <p>
          <strong>{itemName}</strong>
        </p>
      )}

      <div className={classes.modalFooter}>
        <Button label="Close" className="p-button-text" onClick={onHide} />
        <Button label="Yes, I'm Sure" className={classes.confirmButton} onClick={onConfirm} />
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModalBpmByNdcAndJobType;
